import DetailsOcurrence from '../ocurrenceDetails/detailsOcurrence.vue'
import Painelocorrence from '../painelocorrence/painelocorrence.vue'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import ObraVinculoSapRepository from '@/shared/http/repositories/business/obraVinculoSap'
import OcorrenciaCasaRepository from '@/shared/http/repositories/realestate/ocorrenciaCasa'
import { loading, toast } from '@/shared/utils/UIHelper'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'

export default {
  components: {DetailsOcurrence, Painelocorrence},
  props: ['dataDetails'],
  mixins: [AccountMixin, CompanyMixin, PermissionMixin],
  name: 'sorting',
  data () {
    return {
      lflatbutton: false,
      statusOcorencia: 0,
      refreshSubmit: false,
      a: false,
      roles: Roles,
      refreshLog: false,
      unir: {
        empreendimentos: [],
        unidades: [],
        unidadesOptions: [],
        codEmp: null,
        casaIdx: null
      }
    }
  },
  mounted () {
    this.statusOcorencia = this.dataDetails.statusOcorencia
  },
  methods: {
    flatbuttonon () {
      this.lflatbutton = !this.lflatbutton
    },
    aprovar () {
      loading.push()
      OcurrenceRepository.NextStatus(this.dataDetails.id)
        .then((Response) => {
          loading.pop()
          this.dataDetails.statusOcorencia = Response.data
          this.statusOcorencia = Response.data
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error.response.data)
        })
    },
    reprovar () {
      loading.push()
      OcurrenceRepository.ReproveStatus(this.dataDetails.id)
        .then((Response) => {
          loading.pop()
          this.dataDetails.statusOcorencia = Response.data
          this.statusOcorencia = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    refreshResumo (novoValor) {
      this.refreshSubmit = novoValor
    },

    teste (e) {
      this.a = e
    },
    returnstatus () {
      loading.push()
      OcurrenceRepository.ReturnStatus(this.dataDetails.id)
        .then((Response) => {
          loading.pop()
          this.dataDetails.statusOcorencia = Response.data
          this.statusOcorencia = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    abrirUnir () {
      this.unir.codEmp = null
      this.unir.casaIdx = null
      this.unir.unidades = []
      this.unir.unidadesOptions = []
      loading.push()
      ObraVinculoSapRepository.GetEmpreendimentosSap()
        .then(response => {
          const data = (response.data && response.data.data) ? response.data.data : []
          this.unir.empreendimentos = data.map(e => ({ value: e.codEmp, text: e.empreendimento }))
          this.$refs.modalUnirSap.show()
        })
        .catch(err => { console.log(err); toast.error(this.$lang.Common.Alerts.Error) })
        .finally(() => loading.close())
    },
    onChangeEmpreendimento () {
      this.unir.casaIdx = null
      this.unir.unidades = []
      this.unir.unidadesOptions = []
      if (this.unir.codEmp === null) return
      loading.push()
      ObraVinculoSapRepository.GetUnidadesSap(this.unir.codEmp)
        .then(response => {
          this.unir.unidades = (response.data && response.data.data) ? response.data.data : []
          this.unir.unidadesOptions = this.unir.unidades.map((u, i) => ({
            value: i,
            text: `${u.quadra || ''} / ${u.unidade || ''}${u.jaVinculada ? ' (já unida)' : ''}`
          }))
        })
        .catch(err => { console.log(err); toast.error(this.$lang.Common.Alerts.Error) })
        .finally(() => loading.close())
    },
    confirmarUnir () {
      if (this.unir.casaIdx === null) return
      const casa = this.unir.unidades[this.unir.casaIdx]
      loading.push()
      ObraVinculoSapRepository.UnirCasa(casa)
        .then(response => {
          const vinculo = (response.data && response.data.data) ? response.data.data : null
          if (!vinculo || !vinculo.id) throw new Error('vínculo sem id')
          return OcorrenciaCasaRepository.Vincular(this.dataDetails.id, vinculo.id)
        })
        .then(() => {
          toast.success('Chamado unido à casa do SAP.')
          this.dataDetails.temVinculoSap = true
          this.$refs.modalUnirSap.hide()
        })
        .catch(err => { console.log(err); toast.error(this.$lang.Common.Alerts.Error) })
        .finally(() => loading.close())
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/sorting/sorting.js